import { Headers } from '@egw/components'
import { type FeatureFlags } from '@egw/constants'
import { useFlags } from '@egw/feature-flags'
import { FeatureEvergreenIntelligencePage } from '@egw/features-chat'
import { NotFound404 } from '@egw/features-system'
import { useTranslation } from '@egw/i18n'
import { Layout } from '@egw/layouts'
import { type FC } from 'react'

export const EvergreenIntelligencePage: FC = () => {
  const { t } = useTranslation()
  const { flags } = useFlags<FeatureFlags>()

  return (
    <Layout>
      <Headers title={t('pages.evergreen_intelligence.title')} />
      {flags.rolloutCopilotKit ? <FeatureEvergreenIntelligencePage /> : <NotFound404 />}
    </Layout>
  )
}
